import PropTypes from "prop-types";
import paginationShape from "./pagination";

const metaShape = PropTypes.shape({
  averageRating: PropTypes.number.isRequired,
  pagination: paginationShape,
});

export default metaShape;
